'use client';

import Link from 'next/link';
import { Button, HomeIcon } from 'metownlib';

export default function NotFound() {
  return (
    <div className="min-h-screen w-full bg-white flex flex-col justify-center items-center px-4">
      {/* Main content */}
      <div className="text-center max-w-md mx-auto">
        {/* 404 number */}
        <div className="mb-4">
          <h1 className="text-7xl font-light text-gray-300 leading-none">
            404
          </h1>
        </div>

        {/* Error message */}
        <div className="mb-8">
          <h2 className="text-xl font-medium text-gray-900 mb-2">
            Page Not Found
          </h2>
          <p className="text-gray-500 text-sm leading-relaxed">
            The page you're looking for doesn't exist.
          </p>
        </div>

        {/* Action buttons */}
        <div className="space-y-3">
          <Button
            variant="normal"
            size="full"
            rounded="default"
            className="h-11 text-sm font-medium"
            onClick={() => window.history.back()}
          >
            Go Back
          </Button>
        </div>
      </div>

      {/* Footer */}
      <div className="absolute bottom-8 left-0 right-0 text-center">
        <p className="text-sm text-gray-400">© 2025 Metown Inc.</p>
      </div>
    </div>
  );
}
